import classnames from 'classnames';
import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import ClientPortal from '../ClientPortal/ClientPortal';

const Modal = ({ children, centered, className, isOpen, toggle, ...props }) => {
  const ref = useRef();

  // Close the modal if the Escape key is pressed

  useEffect(() => {
    function handleKeyDown(event) {
      if (isOpen && event.key === 'Escape') {
        toggle();
      }
    }

    document.addEventListener('keydown', handleKeyDown);

    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [isOpen, toggle]);

  // Close the modal if the backdrop is clicked

  useEffect(() => {
    function handleBackdropClick(event) {
      if (event.target === ref.current) {
        toggle();
      }
    }

    if (ref.current) {
      ref.current.addEventListener('click', handleBackdropClick);
    }

    return () => ref.current?.removeEventListener('click', handleBackdropClick);
  }, [ref, toggle]);

  // Toggle the .modal-open class on the body

  useEffect(() => {
    document.body.classList.toggle('modal-open', isOpen);
  }, [isOpen]);

  return (
    <ClientPortal>
      {isOpen && (
        <div className={classnames('modal', { 'modal-centered': centered })} data-testid="Modal" ref={ref}>
          <div className={classnames(className, 'modal-dialog')} {...props}>
            {children}
          </div>
        </div>
      )}
    </ClientPortal>
  );
};

Modal.propTypes = {
  centered: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string,
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
};

Modal.defaultProps = {
  centered: false,
  children: null,
  className: null,
};

export default Modal;
